// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-chat-conversation-screen.ios .fic-screen {
  padding-bottom: 20px;
}
.fi-chat-conversation-screen .conversation-name,
.fi-chat-conversation-screen .conversation-controls {
  line-height: 40px;
}
.fi-chat-conversation-screen .fi-chat-conversation-settings-menu .conversation-controls .fi-content-card-top-button {
  height: 40px;
  width: 40px;
  color: var(--fi-color-white);
}
.fi-chat-conversation-screen .fic-screen-content .fi-chat-conversation {
  max-height: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation/fi-chat-conversation-screen/fi-chat-conversation-screen.component.scss"],"names":[],"mappings":"AAEQ;EACI,oBAAA;AADZ;AAKI;;EAEI,iBAAA;AAHR;AAKI;EACI,YAAA;EACA,WAAA;EACA,4BAAA;AAHR;AAMQ;EACI,gBAAA;AAJZ","sourcesContent":[".fi-chat-conversation-screen {\r\n    &.ios {\r\n        .fic-screen {\r\n            padding-bottom: 20px;\r\n        }\r\n    }\r\n\r\n    .conversation-name,\r\n    .conversation-controls {\r\n        line-height: 40px;\r\n    }\r\n    .fi-chat-conversation-settings-menu .conversation-controls .fi-content-card-top-button {\r\n        height: 40px;\r\n        width: 40px;\r\n        color: var(--fi-color-white);\r\n    }\r\n    .fic-screen-content {\r\n        .fi-chat-conversation {\r\n            max-height: 100%;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
